<template>
  <div>
    <v-layout column class="subheading">
      <div v-if="promiseToPayEligible">
        <div class="text-h6 mb-3" data-testid="promise-header">
          {{ chargePeriod }}'s Balance for Unit {{ unitName }}
        </div>
        <v-divider class="mt-2 mb-3" style="width: 25vw" />
        <v-layout class="pb-4 text-h6 font-weight-regular" data-testid="promise-total">
          <v-flex xs8>{{ chargePeriod }} Balance:</v-flex>
          <v-flex xs2 class="text-right">${{ totalBalance(unit).toFixed(2) }}</v-flex>
        </v-layout>
      </div>
      <div v-else>
        <v-layout class="py-4 text-h6 font-weight-regular" data-testid="promise-ineligible-message">
          <v-flex xs12>{{ monthText }} Month is not eligible for Promise-to-Pay.</v-flex>
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
/* eslint-disable no-return-assign */
export default {
  name: "PromiseBreakdown",
  props: {
    months: {
      type: Number
    },
    unit: {
      type: [Object, Array]
    },
    chargePeriod: {
      type: String
    }
  },
  methods: {
    totalBalance(arr) {
      return arr.reduce((acc, currVal) => {
        return acc += parseFloat(currVal.dcTotal);
      }, 0);
    }
  },
  computed: {
    promiseToPayEligible() {
      return this.totalBalance(this.unit) !== 0;
    },

    monthText() {
      return this.months === 1 ? "Current" : "Current + Next";
    },

    unitName() {
      return this.unit[0].sUnitName;
    }
  }
};
</script>
